import { type BlokProps, StoryblokComponentList } from "@trydig/storyblok";
import BlokWrap from "@/components/bloks/BlokWrap";
import type { BlokUspBar } from "@/storyblok";
import styles from "./UspBarBlok.module.css";

export const UspBarBlok = ({ blok, preview }: BlokProps<BlokUspBar>) => {
	return (
		<BlokWrap data-zero-space editable={blok} className={styles.root}>
			{blok.items && (
				<div className={styles.content}>
					<StoryblokComponentList bloks={blok.items} preview={preview} />
				</div>
			)}
		</BlokWrap>
	);
};
